import { Injectable } from '@angular/core';
import { MatOption } from '@angular/material/core';

@Injectable({ providedIn: 'root' })
export class MatOptionLabelService {
  private static readonly LABEL_SELECTOR = '[data-option-label]';
  private patched = false;

  init(): void {
    if (this.patched) return;
    this.patched = true;

    const proto = MatOption.prototype as any;
    const original = Object.getOwnPropertyDescriptor(proto, 'viewValue');
    if (!original?.get) return;

    Object.defineProperty(proto, 'viewValue', {
      configurable: true,
      enumerable: original.enumerable,
      get(this: any): string {
        const label = this._text?.nativeElement?.querySelector?.(MatOptionLabelService.LABEL_SELECTOR) as HTMLElement | null;
        return label ? (label.textContent || '').trim() : original.get!.call(this);
      },
    });
  }
}
